import Dialog from '@/app/[locale]/[ferry]/Dialog'

import { useTranslation } from '@/hooks/useDebugTranslations'

interface Props {
  offerTitle?: string
  onAccept: () => void
  onClose: () => void
  show: boolean
}

export const DepartureWithNoOfferModal = ({ offerTitle, onAccept, onClose, show }: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog
      dataAttr="offer-info"
      description={t('OFFER-MODAL-TITLE', { offerValue: offerTitle ?? '' })}
      headline={t('OFFER-MODAL-TITLE', { offerValue: offerTitle ?? '' })}
      onPrimaryButtonClicked={onAccept}
      onRequestClose={onClose}
      onSecondaryButtonClicked={onClose}
      primaryButtonText={t('OFFER-MODAL-REMOVE')}
      secondaryButtonText={t('CANCEL')}
      show={show}
    />
  )
}
